var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"epg-page"},[_c('EpgContainer',{attrs:{"headerContainer":true,"channelCard":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }